import { useState, useEffect, useRef } from 'react';
import { FaRobot, FaTrophy, FaMedal, FaStar, FaAward, FaFlask } from 'react-icons/fa';
import './Competitions.css';

import imgBestResearch from '../certs/best in research.jpg';
import imgCPElympics from '../certs/cpelympics cert.jpeg';
import imgSumo from '../projects/sumobot pic.png';
import img2ndPlace from '../certs/2nd place.jpeg';

function Competitions() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => new Set([...prev, entry.target.dataset.section]));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    sectionRefs.current.forEach((ref) => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const competitions = [
    {
      icon: <FaMedal />,
      name: 'Best in Research and Prototype',
      year: '2025',
      role: 'Participant / Presenter',
      award: 'Best in Research and Prototype',
      desc: 'Awarded for outstanding research and prototype design at the annual engineering exhibition.',
      color: '#1f4788',
      image: imgBestResearch
    },
    {
      icon: <FaRobot />,
      name: 'Sumo Bot Competition',
      year: '2025',
      role: 'Team Member / Builder',
      award: 'Competitor',
      desc: 'Designed and built an autonomous sumo bot for an in-school robotics competition, implementing sensor-based opponent detection.',
      color: '#5ba3d0',
      image: imgSumo
    },
    {
      icon: <FaAward />,
      name: 'Journal Based Presentation',
      year: '2024',
      role: 'Lead Presenter',
      award: '2nd Place',
      desc: 'Achieved 2nd place in the journal-based presentation competition, showcasing technical research and effective communication skills.',
      color: '#d4a017',
      image: img2ndPlace
    },
    {
      icon: <FaStar />,
      name: 'CPElympics',
      year: '2024',
      role: 'Participant',
      award: 'Participant',
      desc: 'Participated in various engineering challenges and academic events.',
      color: '#1f4788',
      image: imgCPElympics
    }
  ];

  return (
    <section className="competitions-page">
      {/* Header */}
      <div
        className={`competitions-header ${visibleSections.has('header') ? 'visible' : ''}`}
        data-section="header"
        ref={(el) => (sectionRefs.current[0] = el)}
      >
        <div className="header-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="competitions-header-content">
          <h1 className="page-title">Competitions Joined</h1>
          <p className="page-subtitle">Technical events, hackathons, contests, and competitions I've participated in</p>
        </div>
      </div>

      {/* Cards */}
      <div className="competitions-body">
        <div className="competitions-container">
          <div
            className={`competitions-grid-section ${visibleSections.has('grid') ? 'visible' : ''}`}
            data-section="grid"
            ref={(el) => (sectionRefs.current[1] = el)}
          >
            <div className="competitions-grid">
              {competitions.map((comp, index) => (
                <div
                  key={index}
                  className="competition-card"
                  style={{ animationDelay: `${index * 0.12}s` }}
                >
                  <div className="comp-card-top" style={{ background: `linear-gradient(135deg, ${comp.color}, ${comp.color}dd)` }}>
                    {comp.image ? (
                      <img src={comp.image} alt={comp.name} className="comp-card-image" />
                    ) : (
                      <div className="comp-icon">{comp.icon}</div>
                    )}
                  </div>
                  <div className="comp-card-body">
                    <h3 className="comp-name">{comp.name}</h3>
                    <div className="comp-role-badge">
                      <span>{comp.role}</span>
                    </div>
                    <p className="comp-desc">{comp.desc}</p>
                    {comp.award && (
                      <div className="comp-award">
                        <FaTrophy className="award-icon" />
                        <span>{comp.award}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Competitions;
